import { z } from 'zod'

const nickSchema = z
  .string()
  .min(4, 'Tu Nick debe de contener de 4 a 12 caracteres')
  .max(12, 'Tu Nick debe de contener de 4 a 12 caracteres')

const passwordSchema = z.string().min(6, 'Debe contener minimo 6 caracteres')

const requiredCheckbox = (message) =>
  z.boolean().refine((value) => value === true, { message })

const passwordMatchRefine = (schema) =>
  schema.refine((data) => data.password === data.cpassword, {
    message: 'Tus contraseñas no son iguales',
    path: ['cpassword'],
  })

export const loginSchema = z.object({
  username: z.string().min(1, 'Ingresa tu email o usuario'),
  password: z.string().min(1, 'Ingresa tu contraseña'),
  rememberMe: z.boolean().optional(),
})

export const forgotPasswordSchema = z.object({
  email: z.string().email('Email invalido'),
})

export const signupSchema = passwordMatchRefine(
  z.object({
    nick: nickSchema,
    email: z.string().email('Email invalido'),
    password: passwordSchema,
    cpassword: passwordSchema,
    referalCode: z.string().optional(),
    acceptTerms: requiredCheckbox('Debes aceptar los términos y condiciones'),
    checkAge: requiredCheckbox('Debes certificar que eres mayor de 18 años'),
    newsletter: z.boolean().optional(),
  })
)

export const facebookCompleteSchema = passwordMatchRefine(
  z.object({
    nick: nickSchema,
    email: z.string().email('Email ingresado es invalido'),
    password: passwordSchema,
    cpassword: passwordSchema,
    name: z.string().optional(),
    lastName: z.string().optional(),
    referalCode: z.string().optional(),
    acceptTerms: requiredCheckbox('Debes aceptar los términos y condiciones'),
    checkAge: requiredCheckbox('Debes certificar que eres mayor de 18 años'),
    checkGetNews: z.boolean().optional(),
  })
)

export const resetPasswordSchema = passwordMatchRefine(
  z.object({
    password: passwordSchema,
    cpassword: passwordSchema,
  })
)
